import { defineStore } from 'pinia'
//import permissions from '@/services/permissions'
import ApiService from '@/services/api'
import UserService from '@/services/user'

const ENDPOINT = '/users/'

const USRROLES = {
  'BASIC_USER': 'Utilisateur',
  'DRIVER'    : 'Chauffeur',
  'ADMIN_USER': 'Administrateur',
  'SUPER_USER': 'Super Utilisateur',
  //'WORK_SUPERVISOR': 'Référant',
  'EXTERN_USER': 'Externe',
  'PARTNER_USER': 'Partenaire',
}

export const useUserStore = defineStore('user', {
  //storage option
  persist: true,
  // convert to a function
  state: () => ({
    accessToken: null,
    refreshToken: null,
    item: { password: '', customfields: {} },
    me: { id: '', uid: '', companyId: '', firstName: '', lastName: '', middleName: '', spo_id_count: 0 },
    roles: {},
    permissions: {},
    itemList: [],
    basicRoles: [ 'SUPER_USER', 'WORK_SUPERVISOR', 'TEAM_LEADER', 'AGENT', 'BASIC_USER',  'STUDENT' ],
    metaItems: null
  }),
  getters: {
    getRolesArray(){
      return Object.entries(this.roles).map(entry => { return {value: entry[0], text: entry[1]} })
    },
    getAuthorizedRolesArray(){
      return Object.entries(this.roles).map(entry => {
        if( this.me.role === "ADMIN_USER" ){
          return {value: entry[0], text: entry[1]}
        } else if( this.basicRoles.includes(entry[0]) ) {
          return {value: entry[0], text: entry[1]}
        }
      })
    }
    //accessToken: (state) => state.accessToken,
    //refreshToken (state) {
    //  return state.refreshToken
    //},
    //permissions (state) {
    //  return state.permissions
    //}
  },
  actions: {
    async login ({ login, password }) {
      const requestData = {
        method: 'post',
        url: '/accessToken',
        data: {
          client_id: 2,
          client_secret: process.env.VUE_APP_OAUTH_KEY,
          grant_type: 'password',
          username: login,
          password: password
        }
      }
      const response = await ApiService.customRequest(requestData, true)
      this.SET_ACCESS_TOKEN(response.access_token)
      this.SET_REFRESH_TOKEN(response.refresh_token)
      ApiService.setHeader()
      return response
    },
    async logout () {
      await UserService.logout()
      this.REMOVE_ACCESS_TOKEN
      this.REMOVE_REFRESH_TOKEN
    },
    async refreshAccessToken (state) {
      const requestData = {
        method: 'post',
        url: '/accessToken',
        data: {
          client_id: 2,
          client_secret: process.env.VUE_APP_OAUTH_KEY,
          grant_type: 'refresh_token',
          refresh_token: state.refreshToken
        }
      }
      const response = await ApiService.customRequest(requestData, true)
      this.SET_ACCESS_TOKEN(response.access_token)
      this.SET_REFRESH_TOKEN(response.refresh_token)
    },
    fetchItems (options) {
      return new Promise( (resolve, reject) => {
        ApiService.get( ENDPOINT + options ).then( (response) => {
          this.metaItems = response.data.meta
            if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
              this.SET_ITEMS(response.data.data)
            }
            resolve('resolved')
        }).catch( (error) => { 
            reject(error)
        })
    })
      
    },
    fetchItem (id, options) {
      return new Promise( (resolve, reject) => {
        options = (options) ? '/' + options : ''
        if( id && id > 0 ){
          ApiService.get(ENDPOINT + id + options).then( (response) => {
            if( !response.data.data.customfields || Object.prototype.toString.call( response.data.data.customfields ) === '[object Array]' ) {
                response.data.data.customfields = {}
            }
            this.SET_ITEM(response.data.data)
            resolve('resolved')
          }).catch( (error) => { 
            reject(error)
          })
        } else {
          this.RESET_ITEM()
          resolve('resolved')
        }
      })
    },
    fetchMe (options) {
      return new Promise( (resolve, reject) => {
          ApiService.get('/users/me/' + options).then( (response) => {
            this.SET_ME(response.data.data)
            this.SET_ROLES(USRROLES)
            resolve('resolved')
          }).catch( (error) => { 
            reject(error)
          })
      })
    },
    resetPassword(id){
      return new Promise( (resolve, reject) => {
        ApiService.put( '/users/' + id + '/resetpass', {id: id} ).then( () => {
          resolve('resolved')
        }).catch( (error) => {
          reject(error)
        })
      })
    },
    sendMagicLink(id){
      return new Promise( (resolve, reject) => {
        ApiService.put( '/users/' + id + '/magiclink', {id: id} ).then( () => {
          resolve('resolved')
        }).catch( (error) => {
          reject(error)
        })
      })
    },
    storeItem () {
      return new Promise( (resolve, reject) => {
          ApiService.post( ENDPOINT, this.item ).then( (response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
          }).catch( (error) => { 
          reject(error)
          })
      })
    },
    async updateItem () {
      const { data } = await ApiService.put(ENDPOINT + this.item.id, this.item)
      return data
    },
//    can (state, { action, subject }) {
//      const roles = permissions?.[subject]?.[action] || []
//      return roles.includes(state.user.usr_role)
//    },
//    canViewPage (state, option) {
//      let roles = []
//      let page = (typeof option === 'object') ? option.page : option
//      const read = permissions?.[page]?.['read'] || []
//      const update = permissions?.[page]?.['update'] || []
//      roles = [...read, ...update]
//      if( option.right ){
//        roles = permissions?.[page]?.[option.right] || []
//      }
//  
//      return roles.includes(state.user.usr_role)
//    },
    hasRole (role) {
      return role === this.item.role
    },
    buildPermissionsTable () {
      const userRole = this.item.role
      const table = {}
      Object.keys(this.permissions).forEach((subject) => {
        table[subject] = {}
        Object.keys(this.permissions[subject]).forEach((action) => {
          table[subject][action] = this.permissions[subject][action].includes(userRole)
        })
      })
      this.SET_PERMISSIONS_TABLE(table)
    },
    //***************************MUTATIONS ***************************************/
    SET_ACCESS_TOKEN (token) {
      this.accessToken = token
    },
    REMOVE_ACCESS_TOKEN () {
      this.accessToken = null
    },
    SET_REFRESH_TOKEN (token) {
      this.refreshToken = token
    },
    REMOVE_REFRESH_TOKEN () {
      this.refreshToken = null
    },
    SET_ITEM (item) {
      this.item = item
    },
    SET_ME (item) {
      this.me = item
    },
    SET_ITEMS (itemList) {
      this.itemList = itemList
    },
    RESET_ITEM () {
      this.item = { password : '', customfields: {} }
    },
    SET_PERMISSIONS_TABLE (table) {
      this.permissions = table
    },
    SET_ROLES (items) {
      this.roles = items
    },
  }
})
